export const listbookings = {
    // Check-in de una estancia vendida por horas: los campos mínimos
    rapido: "Rápido",
  text1: "Bem-vindo!",
  text2: "Lista de check-ins, gerencie ou envie um link para o registro dos seus hóspedes.",
  text3: "Lista de check-ins",
  text4: "Exportar",
  text5: "Novo check-in",
  text6: "Todos",
  text7: "Pendente",
  text8: "Completo",
  text9: "Hoje",
  text10: "Telefone",
  text11: "Nome",
  text12: "Número do documento",
  text13: "País",
  text14: "Check-in",
  text15: "Chaves",
  text16: "Entregues",
  text17: "Aguardando",
  text18: "Ver informações completas",
  text19: "Documento assinado",
  text20: "Todos",
  text21: "Ocorreu um erro no processo de confirmação de entrega",
  text22: "Informações do check-in",
  text23: "Dados coletados no check-in do hóspede",
  text24: "Nome",
  text25: "Sobrenome",
  text26: "Telefone",
  text27: "Data de hospedagem",
  text28: "Tipo de documento",
  text29: "Passaporte",
  text30: "Documento nacional de identidade",
  text31: "Número do documento",
  text32: "Validade do documento",
  text33: "Nacionalidade",
  text34: "Data de nascimento",
  text35: "Gênero",
  text36: "Feminino",
  text37: "Masculino",
  text38: "Escreva aqui seu ...",
  text39:
    "Olá [guest_name],\nBem-vindo ao HOTEL BARCELO MALAGA!\n\nMuito obrigado por se hospedar conosco. Informamos que o horário de check-out é até às 10h00.\n\nAlém disso, informamos os dados de acesso à nossa rede Wi-Fi:\n\nRede: HOTEL-BARCELO\nSenha: xkamakj1a0\n\n\nEsperamos que sua estadia seja a mais agradável possível.\n\nEstamos à disposição na recepção 24 horas.\n\nAtenciosamente!",
  text40: "O nome da sua acomodação é obrigatório.",
  text41: "As políticas da acomodação são obrigatórias.",
  text42: "É necessário incluir uma mensagem de boas-vindas.",
  text43: "Alterações salvas com sucesso",
  text44: "Erro na solicitação",
  text45: "Registrado com sucesso.",
  text46: "😃 Olá!! ",
  text47:
    " Você concluiu com sucesso o processo de criação da sua primeira acomodação. Agora você pode compartilhar seu QR para que os usuários façam o ",
  text48: "check-in",
  text49: "automatizado 👍",
  text50: "Você pode editar os campos inseridos anteriormente pelo menu",
  text51: "Configurações de modelo.",
  text52: "Baixar",
  text53: "Continuar",
  text54: "Informações do check-in.",
  text55: "Dados do check-in",
  text56: "Data da solicitação:",
  text57: " às",
  text58: "Dados coletados no check-in do hóspede",
  text59: "Nome",
  text60: "Sobrenome",
  text61: "Telefone",
  text62: "Data de hospedagem",
  text63: "Tipo de documento",
  text64: "Passaporte",
  text65: "Documento nacional de identidade",
  text66: "Número do documento",
  text67: "Informações adicionais",
  text68: "Validade do documento",
  text69: "Nacionalidade",
  text70: "Data de nascimento",
  text71: "Gênero",
  text72: "Feminino",
  text73: "Masculino",
  text74: "Fechar",
  text75: "Novo check-in",
  text76:
    "Você pode enviar o link ou criar um check-in manual nas opções a seguir.",
  text77: "Check-in",
  text78: "Check-in manual pelo painel administrativo.",
  text79: "Enviar check-in",
  text80: "Link de reserva para um hóspede.",
  text81: "Carregando, aguarde...",
  text82: "Anos",
  text83: "Dias",

  // Modal exportar
  text84: `EXPORTAR`,
  text85: `Exportar relatórios no WACheckin`,
  text86: `Baixar relatório de check-in`,
  text87: `Baixe os check-ins feitos pelos seus hóspedes e obtenha um
    relatório detalhado com informações como a data do check-in, entre
    outros dados.`,
  text88: `Baixar relatório de migração`,
  text89: `Se a sincronização automática com o órgão de migração falhar,
    você pode baixar este relatório e inserir manualmente os dados
    do seu hóspede.`,

  text90: `Chaves entregues`,
  text91: `Autoridades`,
  text92: `Baixar relatório policial`,
  text93: `Excluir check-in`,
  text94: `Ainda não há hóspedes registrados na sua acomodação`,
  text95: `Os hóspedes registrados aparecerão aqui`,
  text96: `EXPORTAR`,
  text97: `EXPORTAR`,
  text98: `EXPORTAR`,

  // Corrections

  p1: `Enviar`,
  p2: `Link de check-in`,
  p3: `Escanear`,
  p4: `O hóspede assinará neste dispositivo`,
  p5: `Escaneado`,
  p6: `Manual`,
  p7: `Operador manual`,
  p8: `check-ins`,
  p9: `Use a opção de check-in manual para registrar seus hóspedes diretamente na recepção`,
  p10: `Check-in manual`,
  p11: `Envie o link de check-in online aos seus hóspedes por WhatsApp ou e-mail para facilitar o registro antes da chegada`,
  p12: `Enviar check-in online`,
  p13: `Não especificado`,
  p14: `Excluir check-in`,
  p15: `Tem certeza de que deseja excluir o check-in? Não será possível recuperar os dados excluídos`,
  p16: `Excluir`,
  p17: `Cancelar`,
  p18: `Desbloqueie todo o potencial com nossos recursos premium`,
  p19: `Check-in automático via WhatsApp`,
  p20: `Envio de doc. de viajantes`,
  p21: `Verificação de identidade`,
  p22: `Avaliação automática`,
  p23: `Venda cruzada`,
  p24: `Gestão de chaves do hóspede`,
  p25: `Faturamento do hóspede`,
  p26: `Não perca os benefícios!`,
  p27: `Fazer upgrade para o Premium`,

  p28: `Descrição`,
  p29: `Cobrança adicional`,
  p30: `Status`,
  p31: `Pago`,
  p32: `Pendente`,
  p33: `Reembolsado`,
  p34: `Reembolsar cobrança`,
  p35: `Reembolsar`,
  p36: `Tem certeza de que deseja reembolsar a cobrança ao hóspede?`,
  p37: `Documento de identidade`,
  p38: `Passaporte`,
  p39:`FILTRAR`,
  p40:`Check-ins concluídos`,
  p41:`Check-ins em andamento`,
  p42: `Você não tem check-ins em andamento`,
  p43: `Informações do check-in`,
  p44: `Check-ins associados`,
  p45: `Nenhum check-in associado.`,
  p46: `Mais informações:`,
  p47: `Data de check-in:`,
  p48: `Data de check-out:`,

  p49:`Hóspede`,
  p50:`Hóspedes`,


};
